import $ from 'jquery';
import { AJAX_URL } from '../config';

$(document).ready(() => {
  const $favoriteButton = $(
    '.card--recipe-favorite .tile__heart .btn--special'
  );

  if ($favoriteButton.length > 0) {
    $favoriteButton.on('click', function () {
      const $postId = $(this).closest('.card--recipe-favorite').data('post-id');

      $.ajax({
        url: `${AJAX_URL}post_wl_handle_favorites`,
        type: 'POST',
        data: { id: $postId }
      })
        .then(({ success, data: { action, message } }) => {
          if (success) {
            if (action === 'added') {
              $(this).attr('data-user-favorite', 'true');
            } else if (action === 'removed') {
              $(this).attr('data-user-favorite', 'false');
            }
          }

          if (!success && message === 'No User Found') {
            location.href = '/login';
          }
        })
        .catch((err) => console.log(err.message));
    });
  }
});
